import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { serializeFilters } from '@utils/documentVaultUrl';
import { DocumentVaultFilterContext } from '@/contexts/DocumentVaultFilterContext';

/*
  Writes the filter state back to the querystring so a copied URL restores the same view.

  Reading happens in the Provider's initializer instead of here: hydrating from an effect would
  let one unfiltered list paint first, and a shared link should never flash the wrong results.

  Writes use `replace` -- the back button should leave the screen, not step back through every
  keystroke of a search.
*/
export function useVaultFilterUrlSync() {
  const navigate = useNavigate();
  const location = useLocation();
  const { filters } = React.useContext(DocumentVaultFilterContext);

  React.useEffect(() => {
    const nextSearch = serializeFilters(filters);
    const currentSearch = location.search.startsWith('?') ? location.search.slice(1) : location.search;
    if (nextSearch === currentSearch) return;

    navigate({ search: nextSearch ? `?${nextSearch}` : '' }, { replace: true });
  }, [filters, location.search, navigate]);

  return null;
}
